import { cn } from "@tellescope/design-system";
import { ContactDetailsBlockType } from "../../types";
import { BlockSelectionItem } from "./BlockSelectionItem";

export interface BlockSelectionGridProps {
  displayedBlockTypes: ContactDetailsBlockType[];
  selectedBlockTypes: ContactDetailsBlockType[];
  existingBlockCounts?: Partial<Record<ContactDetailsBlockType, number>>;
  onToggleBlock: (blockType: ContactDetailsBlockType) => void;
  className?: string;
}

export const BlockSelectionGrid = ({
  displayedBlockTypes,
  selectedBlockTypes,
  existingBlockCounts,
  onToggleBlock,
  className,
}: BlockSelectionGridProps) => {
  return (
    <div className={cn("grid grid-cols-3 gap-2 p-2", className)}>
      {displayedBlockTypes.map((blockType) => {
        const isSelected = selectedBlockTypes.includes(blockType);

        return (
          <BlockSelectionItem
            key={blockType}
            blockType={blockType}
            isSelected={isSelected}
            existingCount={existingBlockCounts?.[blockType]}
            onClick={() => onToggleBlock(blockType)}
          />
        );
      })}
    </div>
  );
};
